"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScolapassPaymentMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class ScolapassPaymentMapper {
    toDomain(result) {
        const id = lodash_1.default.get(result, "node.PAI_No_Reglt");
        const familyId = lodash_1.default.get(result, "node.FAM_ID");
        const paymentType = lodash_1.default.get(result, "node.PAI_C_Reglt");
        const date = lodash_1.default.get(result, "node.PAI_Date");
        const amount = lodash_1.default.get(result, "node.PAI_Montant");
        return {
            id,
            familyId,
            paymentType,
            date,
            amount,
        };
    }
}
exports.ScolapassPaymentMapper = ScolapassPaymentMapper;
